import "./WidgetParameterItem.css"
import { useDrag, useDrop } from "react-dnd"
import { useEffect, useRef, useState } from "react"
import { faGear, faSave } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Form, InputGroup, Modal } from "react-bootstrap"
import SrvButton from "../../../../components/global/SrvButton";
import { useSelector } from "react-redux"
import StringToDate from "../../../../util/StringToDate"
import axios from "axios"
import { format } from "date-fns"
import ErrorAdd from "../../../../util/ErrorAdd"

function WidgetParameterItem({ idObject, idTask, widthHandler, name, moveParam, index, model, edit, onlyRead }) {

    const [widthModalShow, setWidthModalShow] = useState(false);
    const [inputEditMode, setInputEditMode] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingRef, setLoadingRef] = useState(false);
    const [log, setLog] = useState(null);

    const [ValueBool, setValueBool] = useState(null);
    const [ValueDate, setValueDate] = useState(null);
    const [ValueFloat, setValueFloat] = useState(null);
    const [ValueRef, setValueRef] = useState(null);
    const [ValueString, setValueString] = useState(null);

    const [reference, setReference] = useState([]);

    useEffect(() => {

        /*ID	Name
           1	Логический
           2	Число
           3	Строка
           4	Справочник
           5	Дата */
        if (model.ID_Type === 1) {
            setValueBool(model.Value_Bool);
        }
        else if (model.ID_Type === 2) {
            setValueFloat(model.Value_Float);
        }
        else if (model.ID_Type === 3) {
            setValueString(model.Value_String);
        }
        else if (model.ID_Type === 4) {
            setValueRef(model.Value_Ref);
        }
        else if (model.ID_Type === 5) {
            if (model.Value_Date !== null) {
                const date_format_ = format(new Date(model.Value_Date), 'yyyy-MM-dd');
                setValueDate(date_format_);
            }
        }
    }, [model]);


    useEffect(() => {

        //Если справочник и открыто редактирование
        if (inputEditMode === true & model.ID_Type === 4) {
            setLoadingRef(true);
            axios.get('/api_tracker/parameter/referenceList', { params: { ID_Parameter: model.ID_Parameter } })
                .then((res) => {
                    setLoadingRef(false);
                    setReference(res.data.Data);
                })
                .catch((err) => {
                    setLoadingRef(false);
                    ErrorAdd(err, window.location.href);
                });
        }

    }, [inputEditMode]);

    //console.log(model)

    function widthGet() {
        if (model.Width === 25) {
            return "col-md-3"
        }
        else if (model.Width === 50) {
            return "col-md-6"
        }
        else if (model.Width === 75) {
            return "col-md-9"
        }
        else if (model.Width === 100) {
            return "col-md-12"
        }
        else {
            return "col-md-12"
        }
    }

    function nameGet() {
        /*ID	Name
            1	Логический
            2	Число
            3	Строка
            4	Справочник
            5	Дата */
        if (model.ID_Type === 1) {
            if (model.Value_Bool === null) {
                return "Не заполнено"
            }
            else {
                return model.Value_Bool === true ? "Да" : "Нет"
            }
        }
        else if (model.ID_Type === 2) {
            if (model.Value_Float === null) {
                return "Не заполнено"
            }
            else {
                return model.Value_Float
            }
        }
        else if (model.ID_Type === 3) {
            if (model.Value_String === null) {
                return "Не заполнено"
            }
            else {
                return model.Value_String
            }
        }
        else if (model.ID_Type === 4) {
            if (model.Value_Ref === null) {
                return "Не заполнено"
            }
            else {
                return model.Value
            }
        }
        else if (model.ID_Type === 5) {
            if (model.Value_Date === null) {
                return "Не заполнено"
            }
            else {
                return StringToDate(model.Value_Date)
            }
        }
        else {
            return "Не заполнено"
        }
    }


    //Сохранит значение справочника
    function inputSave() {
        setLog(null);
        setLoading(true);
        var val_bool = null;
        var val_ref = null;

        if (ValueBool == 'true') {
            val_bool = true;
        }
        if (ValueBool == 'false') {
            val_bool = false;
        }
        if (ValueRef != "0") {
            val_ref = ValueRef;
        }

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetParameterValueSet', {
                ID_Task: idTask, ID_Parameter: model.ID_Parameter
                , Value_Bool: val_bool, Value_Float: ValueFloat, Value_String: ValueString, Value_Date: ValueDate, Value_Ref: val_ref
            })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setInputEditMode(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetParameterValueSet', {
                ID_TaskR: idTask, ID_Parameter: model.ID_Parameter
                , Value_Bool: val_bool, Value_Float: ValueFloat, Value_String: ValueString, Value_Date: ValueDate, Value_Ref: val_ref
            })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setInputEditMode(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetParameterValueSet', {
                ID_Board_Task: idTask, ID_Parameter: model.ID_Parameter
                , Value_Bool: val_bool, Value_Float: ValueFloat, Value_String: ValueString, Value_Date: ValueDate, Value_Ref: val_ref
            })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setInputEditMode(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: "param_" + model.ID_Display,
        drop: () => ({
            // model, //Передаем в useDrag
        }),
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }

            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            moveParam({ dragIndex: dragIndex, hoverIndex: hoverIndex })

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: "param_" + model.ID_Display,
        item: () => {
            return { model, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {
                const dragIndex = item.index
                const hoverIndex = index
            }
        }
    })
    const opacity = isDragging ? 0 : 1

    if (edit === true) {
        drag(drop(ref))
    }
    else {
        drag(null)
    }

    return (
        <>
            {widthModalShow === true && (
                <Modal show={widthModalShow} onHide={() => setWidthModalShow(false)} size="sm">
                    <Modal.Body>
                        <div className="modal_title text-center">Выберите ширину параметра</div>
                        <div className="mt-25 text-center">
                            <div href="" className={model.Width === 25 ? "card_param_percent_change active" : "card_param_percent_change"} onClick={() => widthHandler(model.ID_Parameter, 25)}>25%</div>
                            <div href="" className={model.Width === 50 ? "card_param_percent_change active" : "card_param_percent_change"} onClick={() => widthHandler(model.ID_Parameter, 50)}>50%</div>
                            <div href="" className={model.Width === 75 ? "card_param_percent_change active" : "card_param_percent_change"} onClick={() => widthHandler(model.ID_Parameter, 75)}>75%</div>
                            <div href="" className={model.Width === 100 ? "card_param_percent_change active" : "card_param_percent_change"} onClick={() => widthHandler(model.ID_Parameter, 100)}>100%</div>
                        </div>
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="save" size='lg' onClick={() => setWidthModalShow(false)} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )
            }
            <div className={widthGet()} ref={ref} data-handler-id={handlerId} style={{ opacity }}>
                {inputEditMode === false ?
                    (
                        <div className={edit === false ? "card_param" : "card_param edit"} onClick={() => { edit === false && (onlyRead !== true && setInputEditMode(true)) }}>
                            <div className="card_param_name">
                                {name}
                                {edit === true && (<FontAwesomeIcon icon={faGear} className="ml-5 card_param_setting" onClick={() => setWidthModalShow(true)} />)}
                            </div>
                            <div className="card_param_val">
                                {nameGet()}
                            </div>
                        </div>
                    )
                    :
                    (
                        <>
                            {model.ID_Type === 1 && (
                                <>
                                    <div className="input_label">{model.Name}</div>
                                    <InputGroup>
                                        <Form.Select size="sm" disabled={loading} onChange={(e) => setValueBool(e.target.value)} defaultValue={ValueBool} >
                                            <option key={1} value={null} >Не выбрано</option>
                                            <option key={2} value={true}>Да</option>
                                            <option key={3} value={false}>Нет</option>
                                        </Form.Select>
                                        <Button variant="outline-secondary" disabled={loading} onClick={() => inputSave()}>
                                            <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                            {model.ID_Type === 2 && (
                                <>
                                    <div className="input_label">{model.Name}</div>
                                    <InputGroup>
                                        <Form.Control size="sm" type="number" disabled={loading} defaultValue={model.Value_Float} onChange={(e) => setValueFloat(e.target.value)} />
                                        <Button variant="outline-secondary" disabled={loading} onClick={() => inputSave()}>
                                            <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                            {model.ID_Type === 3 && (
                                <>
                                    <div className="input_label">{model.Name}</div>
                                    <InputGroup>
                                        <Form.Control size="sm" type="text" disabled={loading} defaultValue={model.Value_String} onChange={(e) => setValueString(e.target.value)} />
                                        <Button variant="outline-secondary" disabled={loading} onClick={() => inputSave()}>
                                            <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                            {model.ID_Type === 4 && (
                                <>
                                    <div className="input_label">{model.Name}</div>
                                    <InputGroup>
                                        <Form.Select size="sm" disabled={loadingRef} onChange={(e) => setValueRef(e.target.value)} value={ValueRef === null ? 0 : ValueRef}>
                                            <option key={0} value={0}>Не выбрано</option>
                                            {reference.map((item) => (
                                                <option key={item.ID} value={item.ID}>{item.Value}</option>
                                            ))}
                                        </Form.Select>
                                        <Button variant="outline-secondary" disabled={loading} onClick={() => inputSave()}>
                                            <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                            {model.ID_Type === 5 && (
                                <>
                                    <div className="input_label">{model.Name}</div>
                                    <InputGroup>
                                        <Form.Control size="sm" type="date" disabled={loading} defaultValue={ValueDate} onChange={(e) => e.target.value === '' ? setValueDate(null) : setValueDate(e.target.value)} />
                                        <Button variant="outline-secondary" disabled={loading} onClick={() => inputSave()}>
                                            <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                        </>
                    )
                }
                {log !== null && <div className="form_error">{log}</div>}
            </div>
        </>

    )
}

export default WidgetParameterItem;